// Shared inner-page hero: grid + glow backdrop, mono eyebrow, word-reveal
// headline, lede. `titleWords` is the token array from t() (with optional grad).
const PageHero = ({ eyebrow, titleWords, lede, align = "start", children }) => (
  <section className={`page-hero page-hero--${align}`}>
    <div className="page-hero__glow" aria-hidden="true" />
    <div className="page-hero__grid" aria-hidden="true" />
    <div className="page-hero__inner">
      <div className="page-hero__eyebrow eyebrow">
        <span className="eyebrow__label">{eyebrow}</span>
      </div>
      <h1 className="page-hero__title">
        {Array.isArray(titleWords) &&
          titleWords.map((word, i) => (
            <span
              key={`${word.t}-${i}`}
              className={`page-hero__word${word.grad ? " page-hero__word--grad" : ""}`}
              style={{ animationDelay: `${0.1 + i * 0.12}s` }}
            >
              {word.t}
            </span>
          ))}
      </h1>
      {lede && <p className="page-hero__lede">{lede}</p>}
      {children}
    </div>
  </section>
);

export default PageHero;
